import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { fmtIDR } from "@/lib/constants";
import { NumInput } from "@/components/NumInput";
import { Button } from "@/components/ui/button";

export function ItemPriceEdit({ orderId, item, onSaved }) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(item.selling_price != null ? String(item.selling_price) : "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch(`/orders/${orderId}/items/${item.id}/price`, { selling_price: Number(value) });
      toast.success("Item price updated");
      setOpen(false);
      onSaved(data);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  if (!open) {
    return (
      <button type="button" data-testid={`item-edit-price-${item.id}`} onClick={() => setOpen(true)} className="mt-0.5 text-[11px] font-bold text-rose-700 underline-offset-2 hover:underline">
        Edit Price
      </button>
    );
  }

  return (
    <div className="mt-2 space-y-2 rounded-md border bg-accent/40 p-2" data-testid={`item-price-editor-${item.id}`}>
      <p className="text-[11px] text-muted-foreground">Current: <b>{item.selling_price != null ? fmtIDR(item.selling_price) : "—"}</b> · this order only</p>
      <NumInput data-testid={`item-price-input-${item.id}`} className="h-10" placeholder="New price (IDR)" value={value} onValue={setValue} />
      <div className="flex gap-2">
        <Button variant="outline" size="sm" className="h-9 flex-1" data-testid={`item-price-cancel-${item.id}`} onClick={() => setOpen(false)}>Cancel</Button>
        <Button size="sm" className="h-9 flex-1" data-testid={`item-price-save-${item.id}`} disabled={saving || value === ""} onClick={save}>
          {saving ? "Saving…" : "Save Price"}
        </Button>
      </div>
    </div>
  );
}
